import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.title',
		defaultMessage: 'No results found',
		description: 'The title of the pull requests table empty state',
	},
	description: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.description',
		defaultMessage:
			'Try updating your search criteria for better results, or clear filters to view all pull requests from the last 30 days. ',
		description: 'The description of the pull request table empty state.',
	},
	link: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.link',
		defaultMessage: 'Clear filters',
		description: 'The title of the button for clearing filters from the search',
	},
});
